import React, { useState } from "react";
import { Nav, Navbar as Nb } from "react-bootstrap";
import { Link } from "react-router-dom";

function NavBar(){
    const [expanded, setExpanded] = useState(false);
    const navBarStyle = {
        backgroundColor: "#073553",
        paddingLeft: "15px",
        paddingRight: "15px",
        minHeight: "86px",
    }
    const navItemStyle = {
        color: 'white',
        paddingTop: '30px',
        paddingBottom: '30px',
        fontWeight: 'bold'
    }
    return (
        <Nb className="fixed-top" expand="md" style={navBarStyle} variant="dark" expanded={expanded}>
            <Nb.Brand href="http://www.cityofkilgore.com/" target="_blank"><img src={require("../assets/KLG White Line.PNG")} style={{maxHeight: '60px'}} alt="KILGORE"/></Nb.Brand>
            <Nb.Toggle onClick={ () => setExpanded(expanded ? false : "expanded") }/>
            <Nb.Collapse id="navbarCollapse" bg="#073553">
                <Nav bg="#073553">
                    <Link className="nav-link" to="/" style={navItemStyle} onClick={() => setExpanded(false)}><nobr>City of Kilgore Comprehensive Plan</nobr></Link>
                    <Link className="nav-link" to="/meetings" style={navItemStyle} onClick={() => setExpanded(false)}>Meetings</Link>
                    <Link className="nav-link" to="/documents" style={navItemStyle} onClick={() => setExpanded(false)}>Documents</Link>
                    <Link className="nav-link" to="/survey" style={navItemStyle} onClick={() => setExpanded(false)}>Survey</Link>
                    <Link className="nav-link" to="/comment" style={navItemStyle} onClick={() => setExpanded(false)}>Comment</Link>
                </Nav>
            </Nb.Collapse>
        </Nb>
    );
}

export default NavBar;